import { Component } from '@angular/core';

@Component({
  selector: 'app-sms-icon',
  templateUrl: './sms-icon.component.html',
  styleUrl: './sms-icon.component.css'
})
export class SmsIconComponent {

}
